/* JawZen — interactivity (Shopify) */
(function(){
  'use strict';

  var io;

  function setupReveal(root) {
    if(!root) root = document;
    if('IntersectionObserver' in window) {
      if(!io) io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, {threshold:0.12, rootMargin:'0px 0px -8% 0px'});
      root.querySelectorAll('.reveal:not(.in)').forEach(function(el){ io.observe(el); });
    } else {
      root.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
    }
  }

  function setupFaq(root) {
    if(!root) root = document;
    root.querySelectorAll('.faq-item:not([data-fbound])').forEach(function(item){
      item.setAttribute('data-fbound','1');
      var q = item.querySelector('.faq-q');
      var a = item.querySelector('.faq-a');
      if(!q || !a) return;
      q.addEventListener('click', function(){
        var open = item.classList.contains('open');
        item.parentNode.querySelectorAll('.faq-item.open').forEach(function(other){
          if(other !== item){ other.classList.remove('open'); other.querySelector('.faq-a').style.maxHeight = null; }
        });
        if(open){ item.classList.remove('open'); a.style.maxHeight = null; }
        else { item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    });
  }

  function setupCheckoutLinks(root) {
    if(!root) root = document;
    root.querySelectorAll('[data-checkout]:not([data-cbound])').forEach(function(el){
      el.setAttribute('data-cbound','1');
      el.addEventListener('click', function(){
        if(window.fbq){ try{ fbq('track','InitiateCheckout',{value:249.99,currency:'USD'}); }catch(ex){} }
      });
    });
  }

  function setupBuyForm(form) {
    if(!form || form.dataset.bound) return;
    form.dataset.bound = '1';
    // Cart drawer (jz-cart-drawer.js) handles all ATC logic including free gifts
  }

  // ---- Mobile nav menu ----
  function setupMobileMenu() {
    var hamburger = document.getElementById('jz-hamburger');
    var drawer = document.getElementById('jz-nav-mobile');
    if (!hamburger || !drawer || hamburger.dataset.mbound) return;
    hamburger.dataset.mbound = '1';

    function closeMenu() {
      var n = document.getElementById('jz-nav');
      if (n) n.classList.remove('mobile-open');
      hamburger.classList.remove('open');
      hamburger.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
    }

    hamburger.addEventListener('click', function(e) {
      e.stopPropagation();
      var n = document.getElementById('jz-nav');
      var isOpen = n ? n.classList.toggle('mobile-open') : false;
      hamburger.classList.toggle('open', isOpen);
      hamburger.setAttribute('aria-expanded', String(isOpen));
      drawer.setAttribute('aria-hidden', String(!isOpen));
    });

    drawer.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', closeMenu);
    });

    document.addEventListener('click', function(e) {
      var n = document.getElementById('jz-nav');
      if (n && n.classList.contains('mobile-open') && !n.contains(e.target)) closeMenu();
    });

    window.addEventListener('resize', function() {
      if (window.innerWidth > 880) closeMenu();
    });
  }
  setupMobileMenu();

  // ---- Nav scrolled state ----
  var nav = document.getElementById('jz-nav');
  var buybar = document.getElementById('jz-buybar');
  var hero = document.getElementById('jz-hero');
  var buy = document.getElementById('jz-buy');

  function onScroll(){
    var y = window.scrollY || window.pageYOffset;
    if(nav) nav.classList.toggle('scrolled', y > 12);
    if(buybar){
      var heroBottom = hero ? hero.offsetTop + hero.offsetHeight - 120 : 600;
      var buyTop = buy ? buy.offsetTop - window.innerHeight + 120 : 1e9;
      var buyBottom = buy ? buy.offsetTop + buy.offsetHeight : 1e9;
      buybar.classList.toggle('show', y > heroBottom && !(y > buyTop && y < buyBottom));
    }
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', onScroll);
  onScroll();

  // ---- Smooth anchor scroll with fixed-nav offset ----
  document.querySelectorAll('a[href^="#"]').forEach(function(link){
    link.addEventListener('click', function(e){
      var id = link.getAttribute('href');
      if(id.length < 2) return;
      var target = document.querySelector(id);
      if(!target) return;
      e.preventDefault();
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 64, behavior:'smooth' });
    });
  });

  // ---- Initial page setup ----
  if(window.Shopify && window.Shopify.designMode) {
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  } else {
    setupReveal(document);
  }
  setupFaq(document);
  setupCheckoutLinks(document);
  setupBuyForm(document.getElementById('jz-buy-form'));

  // ---- Shopify theme editor section lifecycle ----
  document.addEventListener('shopify:section:load', function(e) {
    var section = e.target;
    if(window.Shopify && window.Shopify.designMode) {
      section.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
    } else {
      setupReveal(section);
    }
    setupFaq(section);
    setupCheckoutLinks(section);
    setupBuyForm(section.querySelector('#jz-buy-form'));
    setupMobileMenu();
    // Re-cache scrollable elements if the relevant sections reloaded
    nav = document.getElementById('jz-nav');
    buybar = document.getElementById('jz-buybar');
    hero = document.getElementById('jz-hero');
    buy = document.getElementById('jz-buy');
    onScroll();
  });

  document.addEventListener('shopify:section:select', function(e) {
    e.target.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  });

})();
